import {atcStates} from '../atc-routes';
export default function AtcFlightsController(
    $state,
    $scope,
    $stateParams,
    atcFlightsFactory,
    atcFlightsService,
    rangeSliderService,
    flightResultsSortTypes,
) {
    'ngInject';

    const vm = this;

    Object.assign(this, {
        $onInit,
        flights: {},
        isBusy: true,
        searchParameters: atcFlightsFactory.params,
        composeCompanyLogoUrl: atcFlightsService.getFlightSupplierLogo,
        areFlightsAvailable,
        showNoResultMessage,
        groupFlights,
        onGroupByPriceChange,
        onSortTypeChange,
    });

    $scope.flights = {};
    $scope.conditions = [];
    $scope.edit = edit;

    function $onInit() {
        const searchConditions = $stateParams.searchConditions;
        $scope.conditions = (searchConditions || {}).Segments || [];
        if ($scope.conditions.length) {
            atcFlightsFactory.fetchFlights(searchConditions).then(function() {
                vm.flights = atcFlightsFactory.getFlights();
                $scope.flights = vm.flights;
            }).finally(function() {
                vm.isBusy = false;
            });
        } else {
            vm.flights.Total = 0;
            vm.isBusy = false;
        }
    }

    $scope.areFiltersVisible = false;
    $scope.filtersChange = {
        changed: false,
    };
    $scope.toggleFilters = toggleFilters;

    function onGroupByPriceChange(value) {
        if (value) {
            vm.sortByType = flightResultsSortTypes.CHEAPEST;
        }
        vm.groupByPrice = value;
        groupFlights();
    }

    function onSortTypeChange(value) {
        if (value !== flightResultsSortTypes.CHEAPEST) {
            vm.groupByPrice = false;
        }
        vm.sortByType = value;
        groupFlights();
    }

    function areFlightsAvailable() {
        return vm.flights.Total > 0;
    }

    function toggleFilters() {
        $scope.areFiltersVisible = !$scope.areFiltersVisible;
        rangeSliderService.forceRenderSlider();
    }

    function groupFlights() {
        vm.searchParameters.GroupByPrice = vm.groupByPrice;
        vm.searchParameters.SortType = vm.sortByType.value;
        atcFlightsFactory.applyFilters(vm.searchParameters.Filters);
    }

    function showNoResultMessage() {
        return vm.flights.Total === 0;
    }

    function edit() {
        $state.go(atcStates.CHECK_RESULT, {
            pnr: vm.searchParameters.Pnr,
            trip: vm.searchParameters.TripId,
            department: vm.searchParameters.DepartmentId,
            fromTripDetails: vm.searchParameters.FromTripDetails,
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/modules/atc/controllers/atcFlightsController.js